import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingSpinnerService } from './shared/services/loading-spinner.service';
import { ModalDirective } from 'angular-bootstrap-md';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject } from 'rxjs';
import { CrashMailService } from 'src/app/shared/services/crash-mail.service';
import { WbidHelper } from 'src/app/shared/utilities/helper';
import { environment } from 'src/environments/environment';
import { JwtAuthenticationComponent } from 'src/app/shared/common-components/jwt-authentication/jwt-authentication.component';
import { WbidCoreService } from 'src/app/shared/services/wbid-core.service';
import { CrashMailInputParameters } from 'src/app/shared/models/CrashMailInputParameters';
import { EmployeeVersionDetails } from './shared/models/EmployeeVersionDetails';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    // if (this.swUpdate.isEnabled) {
    //   setTimeout(() => {
    //     this.checkAndSyncVersion();
    //   }, 5000);
    // }
  }
  title = 'WbidMaxWeb';
  loading: boolean;
  loaderText: any;
  @ViewChild('authentication') public auth: JwtAuthenticationComponent;
  @ViewChild('confirmModal') public confirmModal: ModalDirective;
  version = '2.0';
  private _updateLaterFlag = false;
  offlineStat: BehaviorSubject<boolean> = window['lowLevelOffline'];
  localVersion: string;
  constructor(
    public loaderService: LoadingSpinnerService,
    public snackBar: MatSnackBar,
    private swUpdate: SwUpdate,
    public crashMail: CrashMailService,
    private helperService: WbidHelper,
    private wbidCoreService: WbidCoreService
  ) {
    this.offlineStat.subscribe((onlineStatus) => {
      if (onlineStatus) {
        const pendingCrashDataStr = localStorage.getItem('pendingCrashData');
        let pendingCrashDataArr: CrashMailInputParameters[] = [];
        if (pendingCrashDataStr) {
          pendingCrashDataArr = JSON.parse(pendingCrashDataStr);
          pendingCrashDataArr.forEach((x) => (x.OnlineStatus = false));
          for (let i = 0; i < pendingCrashDataArr.length; i++) {
            this.wbidCoreService
              .SendCrashMail(pendingCrashDataArr[i])
              .subscribe(
                (response) => {
                  if (response.Message.toLowerCase() == 'success') {
                    localStorage.removeItem('pendingCrashData');
                  }
                },
                (error) => {
                  this.crashMail.sendCrashMail(
                    `Function Name:constructor  ${error.stack.toString()}`
                  );
                }
              );
          }
        }
      }
    });
    this.localVersion = environment.version;
    this.loaderService.loading.subscribe((val) => {
      this.loaderText = val.text ? val.text : '';
      this.loading = val.isLoad ? val.isLoad : false;
    });
    this.prompInstall();

    document.addEventListener(
      'visibilitychange',
      () => {
        // console.log(document.hidden, document.visibilityState);
        if (!this._updateLaterFlag)
          setTimeout(() => {
            this.checkAndSyncVersion();
          }, 5000);
      },
      false
    );
  }
ngOnInit(): void {
      if (this.swUpdate.isEnabled) {
      this.loaderService.showSpinner("Checking for latest version...");
      this.checkAndSyncVersion();
    }  
}
  public prompInstall() {
    try {
      if ((navigator as any).standalone == undefined) {
        // It's not iOS
        if (window.matchMedia('(display-mode: browser').matches) {
          let durationForSnackBar = 500000;
          // We are in the browser
          window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            if (durationForSnackBar > 0) {
              const sb = this.snackBar.open(
                'Do you want to install this App?',
                'Install',
                { duration: durationForSnackBar }
              );

              sb.onAction().subscribe(() => {
                (event as any).prompt();
                (event as any).userChoice.then((result) => {
                  if (result.outcome == 'dismissed') {
                    durationForSnackBar = 0;
                  }
                });
              });
            }
            return false;
          });
        }
      }
    } catch (error) {
      this.crashMail.sendCrashMail(
        `Function Name: prompInstall  ${error.stack.toString()}`
      );
    }
  }

  checkAndSyncVersion(): void {
    try {
      const versionDetails: EmployeeVersionDetails =
        new EmployeeVersionDetails();
      this.wbidCoreService.GetAppVersion(versionDetails).subscribe(
        (res) => {
          if (res) {
            this.version = res.VersionNumber;
            versionDetails.version = localStorage.getItem('appVersion');
            if (!this.localVersion) {
              this.localVersion = '9.0.0.0';
            }
            const localVersionArr = this.localVersion.split('.');
            const incomingVersion = this.version.split('.');
            const result = this.helperService.compareVersion(
              localVersionArr,
              incomingVersion
            );
            if (result === 1) {
              this.confirmModal.show();
            } else {
              this.loaderService.hideSpinner();
            }
          }
        },
        (error) => {
          if (error.status === 401) {
            this.auth.invoke();
          } else {
            this.crashMail.sendCrashMail(
              `Function Name: checkAndSyncVersion  ${error.stack.toString()}`
            );
          }
        }
      );
    } catch (error) {
      this.crashMail.sendCrashMail(
        `Function Name: checkAndSyncVersion  ${error.stack.toString()}`
      );
    }
  }

  public clearCache(): void {
    try {
      this.loaderService.showSpinner(
        'Updating the app. which might took few seconds and couple of reloads. Please be patient'
      );
      this.forceSWupdate();
      setTimeout(() => {
        // document.location.reload();
        const url = window.location.origin + "?v=" + Date.now();
        window.location.href = url;
      });
    } catch (error) {
      this.crashMail.sendCrashMail(
        `Function Name: clearCache  ${error.stack.toString()}`
      );
    }
  }

  forceSWupdate() {
    this.updateModalExitBtnHandler();
    if (caches) {
      caches.keys().then((arr) => {
        arr.forEach((key) => {
          caches.delete(key);
        });
      });
    }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
        setTimeout(() => {
          document.location.reload();
        }, 20000);
      });
    }
  }

  public updateModalExitBtnHandler = (): void => {
    this._updateLaterFlag = true;
    this.confirmModal.hide();
  };
}
